import { useGetTreeById } from 'shared/hooks/trees/hooks'
import React, { useMemo } from 'react'
import { createIdMap } from '../../../version_mapping/utility'
import { Box } from '@mui/material'
import { InfoDisplay } from '../../../utility/Containers'
import { FilteredTreeTable } from '../FilteredTreeTable'
import { duplicateSkillIdsFilter } from '../filters'

export function DuplicateStandardsCleanup({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })

  const idMap = useMemo(() => {
    return tree && createIdMap(tree)
  }, [tree])

  return (
    <Box>
      <InfoDisplay>
        <Box>Duplicate Skill Ids</Box>
        <Box>
          The results shown in this table are skill leaves that have a sibling
          leaf with the same skill id. The leaf with the first skill id is not
          included in this set.
        </Box>
      </InfoDisplay>
      <FilteredTreeTable
        filter={duplicateSkillIdsFilter}
        treeId={treeId}
        versionId={versionId}
        action={{ actionType: 'delete' }}
        customColumns={[
          {
            title: 'ParentID',
            rowContent(item) {
              return item.parent_id
            },
          },
          {
            title: 'LeafID',
            rowContent(item) {
              return item.id
            },
          },
          {
            title: 'Keeping',
            rowContent(item) {
              const parent = idMap?.[item.parent_id ?? '']?.node
              const sibling = parent?.leaves?.find(
                ({ body }) => body.skillID === item.body?.skillID,
              )
              return sibling?.id
            },
          },
        ]}
      />
    </Box>
  )
}
